import axios from "axios";
import { VERSION_CHECK_POLL_FREQ, VERSION_CHECK_ERROR } from "@/common/consts";

const COOKIE_NAME = "_YD_LVC";

export default {
    lastCheck: 0,
    checkRequired() {
        this.lastCheck =
            parseInt(window.$cookies.get(COOKIE_NAME)) || this.lastCheck;
        return +new Date() > this.lastCheck + VERSION_CHECK_POLL_FREQ;
    },
    check() {
        return new Promise((resolve, reject) => {
            if (
                this.checkRequired() &&
                typeof window.__PRERENDER_INJECTED === "undefined"
            ) {
                this.lastCheck = +new Date();
                window.$cookies.set(COOKIE_NAME, this.lastCheck);
                axios
                    .get(`/version.json?t=${this.lastCheck}`)
                    .then(version => {
                        if (
                            typeof version.data.v !== "undefined" &&
                            typeof window.appVersion !== "undefined" &&
                            version.data.v !== window.appVersion
                        ) {
                            let e = new Error("Client App requires reload.");
                            e.name = VERSION_CHECK_ERROR;
                            reject(e);
                        }
                    })
                    .finally(() => resolve(true));
            } else {
                resolve(true);
            }
        });
    }
};




// WEBPACK FOOTER //
// ./src/services/VersionService.js